/* eslint-disable */
export default {
  _balloon_expand: 'balloon_expand',
  _boing: 'boing',
  _click: 'click',
  _cloud_walking_60: 'cloud_walking_60',
  _correct1: 'correct1',
  _correct2: 'correct2',
  _deflate: 'deflate',
  _incorrect1: 'incorrect1',
  _incorrect2: 'incorrect2',
  _pop: 'pop',
  _whistle_up: 'whistle_up',
}